import React from 'react';
import { motion } from 'framer-motion';

interface SuccessMessageProps {
  message: string;
}

/**
 * SuccessMessage Component
 *
 * Displays success messages with consistent styling and animations.
 *
 * @component
 * @example
 * ```tsx
 * <SuccessMessage message="Connection successful" />
 * ```
 */
export const SuccessMessage: React.FC<SuccessMessageProps> = ({ message }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-md bg-green-50 border border-green-200 p-4"
      role="alert"
      aria-live="polite"
    >
      <div className="flex">
        <div className="ml-3">
          <h4 className="text-sm font-medium text-green-800">Success</h4>
          <div className="mt-2 text-sm text-green-700">
            <p>{message}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
